/**
 * 게스트 즉시 시작 (지시서 §11: 가입 없이 링크 클릭 → 바로 플레이).
 * 세션의 권위는 서버가 발급한 토큰이며, 로컬에는 그 토큰만 보관한다
 * (게임 상태를 localStorage에 두지 않는다 — 지시서 §6).
 */
import { API_BASE } from '@villager/shared';

const TOKEN_KEY = 'vl_token';

export interface Session {
  token: string;
  playerId: number;
  name: string;
  isGuest: boolean;
}

export function storedToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

function storeToken(t: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, t);
  } catch {
    /* 저장 불가여도 이번 세션은 진행 */
  }
}

/** 기존 토큰이 유효하면 재사용, 아니면 새 게스트를 만든다. */
export async function ensureSession(name = '마을사람'): Promise<Session | null> {
  const existing = storedToken();
  if (existing) {
    try {
      const res = await fetch(`${API_BASE.villager}/auth/me`, {
        headers: { authorization: `Bearer ${existing}` },
      });
      if (res.ok) {
        const me = (await res.json()) as { player_id: number; name: string; is_guest: boolean };
        return { token: existing, playerId: me.player_id, name: me.name, isGuest: me.is_guest };
      }
    } catch {
      return null;
    }
  }
  try {
    const res = await fetch(`${API_BASE.villager}/auth/guest`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ name }),
    });
    if (!res.ok) return null;
    const t = (await res.json()) as { token: string; player_id: number; name: string };
    storeToken(t.token);
    return { token: t.token, playerId: t.player_id, name: t.name, isGuest: true };
  } catch {
    return null;
  }
}
